module.exports = __webpack_public_path__ + "img/icon-double-arrow-down.dd32782d.svg";